import React from "react";
// import logo_white from "../upload/logo_white3.png";
import { useLoader } from "../context/LoaderContext";
import { useCompanyDetailsContext } from "../context/CompanyDetailsContext";

const Loader = () => {
  const { loading } = useLoader();
  const { companyDetailsData } = useCompanyDetailsContext();
  return (
    <>
      {loading && (
        // <div style={{ background: "#000", height: "100dvh" }}>
        <div
          id="loftloader-wrapper"
          className="pl-imgloading"
          data-show-close-time="15000"
          data-max-load-time="0"
        >
          <div className="loader-inner">
            {companyDetailsData.length > 0 ? (
              <div id="loader" style={{ width: "184.76px", height: "160px" }}>
                <div className="imgloading-container">
                  <span
                    style={{
                      backgroundImage: `url(${process.env.REACT_APP_cmsUrl}${companyDetailsData[0]?.primary_logo_color?.[0]?.media?.url})`,
                      width: "184.76px",
                      height: "160px",
                    }}
                  ></span>
                </div>
                <img
                  data-no-lazy="1"
                  className="skip-lazy"
                  alt="loader"
                  src={`${process.env.REACT_APP_cmsUrl}${companyDetailsData[0]?.primary_logo_color?.[0]?.media?.url}`}
                  style={{ width: "184.76px", height: "160px" }}
                />
              </div>
            ) : (
              <div className="static-loader-inner">
                <div className="static-loader"></div>
              </div>
            )}
          </div>
          <div className="loader-section section-fade"></div>
          <div className="loader-close-button" style={{ display: "none" }}>
            <span className="screen-reader-text">Close</span>
          </div>
          <div className="custom-gradient" style={{ zIndex: "10000" }}></div>
        </div>
        // </div>
      )}
    </>
  );
};

export default Loader;
